import { Disclosure } from "../../../components/Disclosure";
import { FiltroKits } from "./components/FiltroKits";
import { useMemo, useState } from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { createColumnHelper } from "@tanstack/react-table";
import { Loading, QueryError } from "@/components/Loading/Loading";
import { TypedTable } from "@/components/TypedTable";
import { ModalEditarKit } from "./components/ModalEditarKit";
import { useArticulosKits, type ArticuloKit } from "@/hooks/Api/KitsFabricacion";
import "./GestionKits.scss";

export function GestionKitsPage() {
	const [filtroFamilia, setFiltroFamilia] = useState<string[]>([]);
	const [filtroKit, setFiltroKit] = useState<boolean | null>(null);
	const queryArticulos = useArticulosKits();

	const articulosFiltrados = useMemo(() => {
		const kitFilter: ((art: ArticuloKit) => boolean) = filtroKit == null ? () => true :
			(filtroKit ? art => Boolean(art.componentes) : art => !art.componentes);

		const familiaFilter: ((art: ArticuloKit) => boolean) = filtroFamilia.length === 0 ? () => true : art => art.idFamilia !== null && filtroFamilia.includes(art.idFamilia.toString());
		if (queryArticulos.data == null) return [];

		return queryArticulos.data.filter(kitFilter).filter(familiaFilter);
	}, [queryArticulos.data, filtroFamilia, filtroKit]);


	if (queryArticulos.error) return <QueryError error={queryArticulos.error} fallback="Error al cargar los kits" />;

	return (
		<div id="content" className="content" >
			<title>Rial | Gestión Kits</title>
			<div>

				<Breadcrumb
					sectionTitle="Asignar Kits"
					links={[
						{ label: "Asignar Kits", active: true }
					]}
				/>


				<Disclosure style={{ marginBottom: 20 }}>
					<h4 className="panel-title panel-heading senalar">
						Filtro
					</h4>
					<FiltroKits familia={filtroFamilia} setFamilia={setFiltroFamilia} kit={filtroKit} setKit={setFiltroKit} />
				</Disclosure>
			</div>

			<div id="tablaKits">
				<h1 style={{ marginBottom: 0 }}> Artículos </h1>
				{queryArticulos.isPending
					? <Loading />
					: <TablaArticulosKits articulosConKit={articulosFiltrados} />}
			</div>

		</div>
	);
}

interface TablaArticulosKitsProps {
	readonly articulosConKit: ArticuloKit[] | null;
}
function TablaArticulosKits(props: TablaArticulosKitsProps) {
	const [kitDisplayed, setKitDisplayed] = useState<number | null>(null);
	const [articuloEditando, setArticuloEditando] = useState<ArticuloKit | null>(null);

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<ArticuloKit>();

		const getAccionesArticulo = (articulo: ArticuloKit) => {
			return (
				<div className="clickable mostrarModalLanzarInputacion" data-id-articulo={articulo.idArticulo}>
					<i style={{ fontSize: 24 }} className={`fa fa-${articulo.componentes != null ? "pen-to-square" : "plus"}`} />
				</div>
			);
		};

		const getKits = (articulo: ArticuloKit) => {
			const elements = articulo.componentes?.map(comp => (
				<span key={comp.idComponente}>
					{comp.descComponente} x{comp.cantidadPorUnidad}
				</span>
			));
			if (!elements) return <div className="comp-list"></div>;

			return <div className="comp-list">
				{(elements.length > 3 && kitDisplayed !== articulo.idArticulo) ?
					<div className="cutted-comps comp-list" onClick={() => setKitDisplayed(articulo.idArticulo)}>
						{elements.slice(0, 2)}
						<span className="hidden-comps">({elements.length - 2} ocultos)</span>
					</div>
					: elements}
			</div>;
		};

		return [
			columnHelper.accessor("descripcionFamilia", { header: "Familia", cell: info => info.getValue() ?? "-", meta: { className: "dt-center" } }),
			columnHelper.accessor("referencia", { header: "Referencia", cell: info => info.getValue(), meta: { className: "dt-center" } }),
			columnHelper.accessor("descArticulo", { id: "articulo", header: "Artículo", meta: { className: "dt-center" } }),
			columnHelper.group({
				id: "components",
				header: "Kit",
				meta: "dt-center",
				cell: ({ row }) => getKits(row.original),
			}),
			columnHelper.display({
				id: "actions",
				header: "",
				meta: { className: "p-0 h-full" },
				cell: ({ row }) => getAccionesArticulo(row.original),
			}),

		];
	}, [kitDisplayed]);

	const onClickDT = (event: React.MouseEvent<HTMLDivElement>) => {
		const target = (event.target as HTMLElement | null)?.closest(".mostrarModalLanzarInputacion") as HTMLElement | null;
		if (!target) {
			return;
		}
		const idArticulo = parseInt(target.dataset.idArticulo ?? "", 10);
		const articulo = props.articulosConKit?.find(art => art.idArticulo === idArticulo);
		if (articulo) {
			setArticuloEditando(articulo);
		}
	};
	return <div onClick={onClickDT}>
		<TypedTable
			className="dataTable display"
			data={props.articulosConKit ?? []}
			columns={columns}

			pagination
			globalSearch
		/>
		<ModalEditarKit
			shown={articuloEditando != null}
			close={() => setArticuloEditando(null)}
			articuloConKit={articuloEditando}
		/>
	</div>;
}
